/* Mesmerize · Customer photo pile · mes-review-pile.js (no dependencies)
   Pile order, fling, hover tilt + glare, typewriter quote, one-time stamp. Grain + glow drift are CSS animations that
   run only while the section is on screen (.is-vis). */
(function () {
  'use strict';
  var POS = ['translate(0px,0px) rotate(-2deg)', 'translate(16px,10px) rotate(4deg)', 'translate(-14px,18px) rotate(-6deg)'];
  var EASE = 'cubic-bezier(.2,.8,.2,1)';
  var CPS = 53.3; /* design: 1.6 characters per 30ms frame */

  function init(root) {
    if (root.__msr) return;
    var stack = root.querySelector('[data-msr-stack]');
    if (!stack) return;
    var all = Array.prototype.slice.call(stack.querySelectorAll('[data-msr-card]'));
    var cards = all, N = all.length; if (!N) return;
    /* Persistent men/women view (4 Nov 2026): only reviews for the chosen gender stay in the pile (cards carry
       data-g-card from their product; snippets/mes-gender hides the rest). A choice that would empty the pile keeps it whole. */
    function pick() {
      var g = window.mesGender && window.mesGender.get();
      var keep = all.filter(function (c) { var t = c.getAttribute('data-g-card'); return !g || !t || t === g; });
      if (!keep.length) { all.forEach(function (c) { c.removeAttribute('data-g-card'); }); keep = all; }
      cards = keep; N = keep.length; top = 0;
    }
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var typeOn = root.getAttribute('data-type') === '1' && !reduce;
    var fling = +root.getAttribute('data-fling') || 70;
    var stamp = root.querySelector('[data-msr-stamp]');
    var top = 0, busy = false, gd = null, moved = false, rect = null, vis = false, stamped = false;
    var typeEl = null, typeFull = '', typeN = 0, raf = 0, prevTs = 0, timers = [], ios = [];
    var api = root.__msr = {};
    root.classList.add('msr--js');

    function inner() { var c = cards[top]; return c && c.querySelector('[data-tilt]'); }
    function layout() {
      cards.forEach(function (c, i) {
        var k = (i - top + N) % N;
        c.setAttribute('data-k', k);
        c.style.zIndex = N - k;
        c.style.transform = POS[Math.min(k, 2)];
        c.classList.toggle('is-deep', k > 2);
        c.setAttribute('aria-current', k === 0 ? 'true' : 'false');
      });
      startType();
    }
    function startType() {
      cards.forEach(function (c, i) {
        var q = c.querySelector('[data-gq]'); if (!q) return;
        var full = q.__f || (q.__f = q.textContent);
        if (i !== top || !typeOn) { if (q.textContent !== full) q.textContent = full; }
      });
      if (!typeOn) return;
      var q = cards[top].querySelector('[data-gq]'); if (!q) return;
      typeEl = q; typeFull = q.__f; typeN = 0; q.textContent = '';
      kick();
    }
    function loop(ts) {
      raf = 0;
      if (!typeEl || !vis || document.hidden) { prevTs = 0; return; }
      if (prevTs) typeN = Math.min(typeFull.length, typeN + Math.min(ts - prevTs, 50) / 1000 * CPS);
      prevTs = ts;
      var txt = typeFull.slice(0, Math.floor(typeN));
      if (typeEl.textContent !== txt) typeEl.textContent = txt;
      if (typeN >= typeFull.length) { typeEl = null; prevTs = 0; return; }
      raf = requestAnimationFrame(loop);
    }
    function kick() { if (typeEl && vis && !document.hidden && !raf) raf = requestAnimationFrame(loop); }

    function reset() {
      var i = inner(); if (!i) return;
      i.style.transition = 'transform .5s ' + EASE; i.style.transform = 'none';
      var gl = i.querySelector('[data-glare]'); if (gl) gl.style.backgroundPosition = '120% 0';
    }
    function flingTop(dir, dy) {
      var i = inner(); if (!i || busy) return;
      busy = true;
      if (reduce) { top = (top + 1) % N; layout(); busy = false; return; }
      i.style.transition = 'transform .36s cubic-bezier(.4,0,.6,1), opacity .36s';
      i.style.transform = 'translate(' + dir * 520 + 'px,' + (dy - 40) + 'px) rotate(' + dir * 28 + 'deg)';
      i.style.opacity = '0';
      timers.push(setTimeout(function () {
        i.style.transition = 'none'; i.style.transform = 'none';
        top = (top + 1) % N; layout();
        requestAnimationFrame(function () { i.style.transition = 'opacity .45s ease .15s'; i.style.opacity = '1'; busy = false; });
      }, 360));
    }
    function prev() { if (busy) return; reset(); top = (top - 1 + N) % N; layout(); }

    function onDown(e) {
      if (e.button > 0) return;
      gd = { x: e.clientX, y: e.clientY, dx: 0, dy: 0, id: e.pointerId }; moved = false;
    }
    function onMove(e) {
      var i = inner(); if (!i) return;
      if (gd) {
        gd.dx = e.clientX - gd.x; gd.dy = e.clientY - gd.y;
        /* capture only once it is really a drag, so a plain tap on the name link still clicks */
        if (!moved && Math.abs(gd.dx) > 6) { moved = true; try { stack.setPointerCapture(gd.id); } catch (_) {} }
        if (busy) return;
        i.style.transition = 'none';
        i.style.transform = 'translate(' + gd.dx + 'px,' + gd.dy * .4 + 'px) rotate(' + gd.dx * .06 + 'deg)';
        return;
      }
      if (e.pointerType !== 'mouse' || reduce || busy) return;
      if (!rect) rect = stack.getBoundingClientRect();
      var px = (e.clientX - rect.left) / rect.width - .5, py = (e.clientY - rect.top) / rect.height - .5;
      i.style.transition = 'transform .12s ease-out';
      i.style.transform = 'perspective(900px) rotateX(' + (-py * 10) + 'deg) rotateY(' + (px * 12) + 'deg)';
      var gl = i.querySelector('[data-glare]'); if (gl) gl.style.backgroundPosition = (120 - (px + .5) * 140) + '% 0';
    }
    function onUp() {
      var g = gd; gd = null; rect = null; if (!g) return;
      if (Math.abs(g.dx) > fling) flingTop(g.dx > 0 ? 1 : -1, g.dy * .4); else reset();
    }
    function onLeave() { rect = null; if (gd && !moved) gd = null; if (!gd) reset(); }
    function onClick(e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }
    function onNext() { flingTop(-1, 0); }

    var prevBtn = root.querySelector('[data-msr-prev]'), nextBtn = root.querySelector('[data-msr-next]');
    stack.addEventListener('pointerdown', onDown);
    stack.addEventListener('pointermove', onMove);
    stack.addEventListener('pointerup', onUp);
    stack.addEventListener('pointercancel', onUp);
    stack.addEventListener('pointerleave', onLeave);
    stack.addEventListener('click', onClick, true);
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', onNext);

    function land() {
      if (stamped || !stamp) return;
      stamped = true;
      if (reduce) { stamp.classList.add('is-in'); return; }
      stamp.style.transition = 'transform .3s cubic-bezier(.55,0,.85,.35), opacity .12s ease';
      stamp.classList.add('is-in');
      timers.push(setTimeout(function () {
        if (stack.animate) stack.animate([{ transform: 'translate(0,0)' }, { transform: 'translate(2px,3px)' }, { transform: 'translate(-2px,-1px)' }, { transform: 'translate(0,0)' }], { duration: 220, easing: 'ease-out' });
        if (stamp.animate) stamp.animate([{ transform: 'scale(1) rotate(-12deg)' }, { transform: 'scale(.94) rotate(-12deg)' }, { transform: 'scale(1) rotate(-12deg)' }], { duration: 200, easing: 'ease-out' });
      }, 300));
    }

    function onVis() { kick(); }
    function onScroll() { rect = null; }
    document.addEventListener('visibilitychange', onVis);
    addEventListener('scroll', onScroll, { passive: true });
    if (window.IntersectionObserver) {
      var io1 = new IntersectionObserver(function (es) {
        vis = es[0].isIntersecting; root.classList.toggle('is-vis', vis); kick();
      });
      io1.observe(stack); ios.push(io1);
      if (stamp) {
        /* stamp lands when the pile's top edge passes 62% of the viewport height (or the page loads already past it) */
        var io2 = new IntersectionObserver(function (es) {
          var e = es[0];
          if (e.isIntersecting || e.boundingClientRect.top < innerHeight * .62) { land(); io2.disconnect(); }
        }, { rootMargin: '0px 0px -38% 0px' });
        io2.observe(stack); ios.push(io2);
      }
    } else { vis = true; root.classList.add('is-vis'); land(); }

    api.select = function (idx) { var i = cards.indexOf(all[idx]); if (i < 0 || busy) return; reset(); top = i; layout(); };
    function onGender() { if (busy) return; reset(); pick(); layout(); }
    document.addEventListener('mes:gender', onGender);
    api.destroy = function () {
      ios.forEach(function (o) { o.disconnect(); });
      timers.forEach(clearTimeout); if (raf) cancelAnimationFrame(raf);
      document.removeEventListener('visibilitychange', onVis);
      removeEventListener('scroll', onScroll);
      stack.removeEventListener('pointerdown', onDown); stack.removeEventListener('pointermove', onMove);
      stack.removeEventListener('pointerup', onUp); stack.removeEventListener('pointercancel', onUp);
      stack.removeEventListener('pointerleave', onLeave); stack.removeEventListener('click', onClick, true);
      if (prevBtn) prevBtn.removeEventListener('click', prev);
      if (nextBtn) nextBtn.removeEventListener('click', onNext);
      document.removeEventListener('mes:gender', onGender);
      root.__msr = null;
    };
    pick(); layout();
  }

  function boot(scope) {
    var s = scope || document;
    if (s.classList && s.classList.contains('msr')) { init(s); return; }
    Array.prototype.forEach.call(s.querySelectorAll('.msr'), init);
  }
  function start(scope) {
    var roots = (scope || document).querySelectorAll('.msr');
    if (!window.IntersectionObserver) { boot(scope); return; }
    Array.prototype.forEach.call(roots, function (r) {
      if (r.__msr || r.__msrW) return;
      r.__msrW = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        r.__msrW.disconnect(); r.__msrW = null; init(r);
      }, { rootMargin: '200px 0px' });
      r.__msrW.observe(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); }); else start();
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('.msr'), function (r) {
      if (r.__msrW) { r.__msrW.disconnect(); r.__msrW = null; }
      if (r.__msr && r.__msr.destroy) r.__msr.destroy();
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest && e.target.closest('[data-msr-card]'); if (!card) return;
    var r = card.closest('.msr'); if (!r) return;
    if (!r.__msr) { if (r.__msrW) { r.__msrW.disconnect(); r.__msrW = null; } init(r); }
    if (r.__msr && r.__msr.select) r.__msr.select(+card.getAttribute('data-msr-card'));
  });
})();
